import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-trp-redirect',
    templateUrl: './trp-redirect.component.html',
    styleUrls: ['./trp-redirect.component.css'],
    standalone: false
})
export class TrpRedirectComponent implements OnInit {

  token: string;
  tin : string;
  name : string;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private jwtHelper: JwtHelperService,
              private toastr: ToastrService) { }

  ngOnInit(): void {
    this.setTokenInfoToLocalStorage();
    //console.log();
  }

  setTokenInfoToLocalStorage() {

    let decodeTOken;
    this.token = this.activatedRoute.snapshot.params["token"];
    //this.activeRoutes.queryParams.subscribe(param => this.token = param.token);
    try {
      decodeTOken = this.jwtHelper.decodeToken(this.token);
    } catch(e){

      this.toastr.error("Token not validate");
      this.router.navigate(["/auth/sign-in"]);
      return;
    }
    this.tin = decodeTOken['sub'];
    this.name = decodeTOken['claims']['userFullName'];
    localStorage.setItem('tin', this.tin);
    localStorage.setItem('token', this.token);
    localStorage.setItem('name', this.name);

    this.router.navigate(["/user-panel/home"]);
  }


}
